import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as _ from 'lodash'
import { BLUE } from '../../../../styles'
import Text from 'components/common/Text'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 45px;
  margin-top: 10px;
`
const NameContainer = styled.div`
  display: flex;
  width: 125px;
  height: 30px;
  align-items: center;
  justify-content: space-between;
`
const ResetTextContainer = styled.div`
  margin-left: 30px;
  cursor: pointer;
`
const ButtonLayout = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: #eaf7ff;
  border: solid ${props => props.selected ? 2 : 1}px ${BLUE};
  cursor: pointer;
  ${props => props.effect};
  margin-right: 10px;
`
// the 'type' field should be unique here
const effectShadow = {
  type: 'simpleShadow',
  params: [{
    paramName: 'text-shadow',
    value: `-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;`
  }]
}

const effectShadowBlackLight = {
  type: 'simpleShadowBlackLight',
  params: [{
    paramName: 'text-shadow',
    value: '0px 0px 1px #000;'
  }]
}

const effectShadowBlack = {
  type: 'simpleShadowBlack',
  params: [{
    paramName: 'text-shadow',
    value: '0px 0px 3px #000;'
  }]
}

const effectShadowWhite = {
  type: 'simpleShadowWhite',
  params: [{
    paramName: 'text-shadow',
    value: `-1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;`
  }]
}

class SPTextEffect extends Component {

  onClick = (effect) => {
    const { onChange, currentValue } = this.props
    return () => {
      if (_.has(currentValue, ['type']) && currentValue.type === effect.type) {
        this.props.onChange({})
      } else {
        onChange(effect)
      }
    }
  }

  onReset = () => { this.props.onChange({}) }

  renderButton = (effectInfo) => {
    const { currentValue } = this.props
    const strParams = _.map(effectInfo.params, p => `${p.paramName}: ${p.value}`)
    const effect = _.join(strParams, '\n')
    return (
      <ButtonLayout
        effect={effect}
        onClick={this.onClick(effectInfo)}
        selected={_.has(currentValue, ['type']) && currentValue.type === effectInfo.type}
      >
        <Text>A</Text>
      </ButtonLayout>
    )
  }

  render () {
    const { title } = this.props
    return (
      <Container>
        <NameContainer>
          <Text size='medium'>{title}</Text>
        </NameContainer>

        {this.renderButton(effectShadowWhite)}
        {this.renderButton(effectShadow)}
        {this.renderButton(effectShadowBlack)}
        {this.renderButton(effectShadowBlackLight)}

        <ResetTextContainer onClick={this.onReset} >
          <Text size='medium'>RESET</Text>
        </ResetTextContainer>
      </Container>
    )
  }
}

SPTextEffect.defaultProps = {
  currentValue: {},
  onChange: () => null,
  title: ''
}

SPTextEffect.propTypes = {
  currentValue: PropTypes.object,
  onChange: PropTypes.func,
  title: PropTypes.string
}

export default SPTextEffect



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/stylePresetComponents/SPTextEffect.js